import LiquidEmeraldQuantityAdapter from './LiquidEmeraldQuantityAdapter'

export default LiquidEmeraldQuantityAdapter
